import {React, classObserver, observer} from '@api';
import {Tooltip2} from '@api'

import {Tab, Tabs, Tooltip} from '@material-ui/core';
import {FilterList, LocalLibrary} from '@material-ui/icons';
import {useStores} from '@modules'
import { useCatalog} from '@stores'
import {icons} from '@stores/ui'
import {action} from 'mobx'
import * as css from './LibrarySidebarTabs.css';

interface MyProps {
 showAttributes?: boolean
 showFilters?: boolean
}

export interface SidebarTabProps {
  title?: string,
  classes?: any,
  icon?: React.ReactElement<any>
}

export const SidebarTab = ({title, classes, icon, ...p} : SidebarTabProps) => <Tab {...p} className={css.sidebarTab} icon={<Tooltip2 placement='bottom' content={title}>{icon}</Tooltip2>} />

const LibraryTab = observer<any>(function LibraryTab(p) {
  const {strings} = useStores()
  return <SidebarTab {...p} icon={icons.catalogLibrary} data-tab='libraries' title={strings.specLibraries} selected={p.selected}/>
})

//const AttributesTab = styled(SidebarTab).attrs(() => ({ title: strings.attributes(catalog), icon: <Style />}))``
const FiltersTab = observer<any>(function FiltersTab(p) {
  const {strings} = useStores()
  return <SidebarTab {...p} data-tab='filters' title={strings.filters} icon={<FilterList/>} selected={p.selected}/>
})

export const LibrarySidebarTabsStyles = css

export const LibrarySidebarTabs  = observer<MyProps>(function LibrarySidebarTabs() {
  const stores = useStores()

  const {
      workspaces: {view},
      flexLayout: {maximizedTab, isShowingLibraries, isShowingFilters},
      catalog: {hasLoadedConfig, workspaceConfig, groupBy: {groupByFields}, shouldRenderLibraryTab},
      sidebar: {left, left: {onChangeTab, tab, open}}
    } = stores


  if (!hasLoadedConfig) return null

  // console.log({isShowingLibraries, isShowingFilters })
  return (
    <Tabs
      className={css.tabs}
      value={!maximizedTab || !open ? false : tab}
      indicatorColor='secondary'
      textColor='secondary'
      onChange={left.onChangeTab}
    >
      {view == 'catalog' && shouldRenderLibraryTab && <LibraryTab selected={isShowingLibraries}/>}
      {/*{showAttributes && <AttributesTab/>}*/}
      {view == 'catalog' && groupByFields.length > 0 && <FiltersTab selected={isShowingFilters} />}
      {view == 'library' && workspaceConfig?.library?.tabs?.length > 1 &&
       workspaceConfig.library.tabs.map(({id, label}) => <Tab key={id} label={label}/>)}
    </Tabs>
  )
})




// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/LibrarySidebarTabs.tsx